import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { UsuarioSharedModule } from '../../usuario';

import { PedidoExcelListagemModalComponent } from './listagem';

@NgModule({
    imports: [
        SharedModule,
        UsuarioSharedModule
    ],
    declarations: [
        PedidoExcelListagemModalComponent
    ],
    exports: [
        PedidoExcelListagemModalComponent
    ]
})
export class PedidoExcelModule { }
